import { jsxs as p, jsx as t } from "react/jsx-runtime";
import { tv as i } from "tailwind-variants";
const n = i({
  slots: {
    wrapper: [
      "h-[26px]",
      "relative",
      "w-[34px]",
      "*:absolute",
      "*:bg-neutral-900",
      "*:rounded",
      "*:h-[4px]",
      "*:w-full",
      "*:left-0",
      "*:transition",
      "*:origin-center"
    ],
    top: ["top-0"],
    middle: ["top-[calc(50%-2px)]"],
    bottom: ["bottom-0"]
  },
  variants: {
    isActive: {
      true: {
        top: ["rotate-45", "translate-x-[0px]", "translate-y-[12px]"],
        middle: ["opacity-0"],
        bottom: ["-rotate-45", "translate-x-[0px]", "translate-y-[-10px]"]
      }
    }
  }
}), d = ({ className: a, isActive: e }) => {
  const { wrapper: o, top: s, middle: r, bottom: l } = n({ isActive: e });
  return /* @__PURE__ */ p("div", { className: o({ class: a }), children: [
    /* @__PURE__ */ t("div", { className: s() }),
    /* @__PURE__ */ t("div", { className: r() }),
    /* @__PURE__ */ t("div", { className: l() })
  ] });
};
export {
  d as default
};
